import { makeAutoObservable } from 'mobx';

import { Organization } from '../models/Company';
import { UserService } from '../services/UserService';
import sessionStore from './SessionStore';

class OrganizationStore {
  organizations: Organization[] = [];

  selectedOrg: number | null = null;
  userId: number | null = null;

  constructor() {
    makeAutoObservable(this);
    this.loadSelectedOrg();
  }

  setOrganizations(organizations: Organization[]) {
    this.organizations = organizations;
  }

  setSelectedOrg(orgId: number) {
    this.selectedOrg = orgId;
    this.persistSelectedOrg();
    const userId = sessionStore.user?.id;
    if (userId) {
      UserService.updateUser(userId, { last_selected_org: orgId }).then((user) => {
        if (user) {
          sessionStore.setUser(user);
        }
      });
    }
  }

  persistSelectedOrg() {
    if (this.selectedOrg !== null) {
      localStorage.setItem('selectedOrg', this.selectedOrg.toString());
    } else {
      localStorage.removeItem('selectedOrg');
    }
  }

  loadSelectedOrg() {
    const storedOrgId = localStorage.getItem('selectedOrg');
    if (storedOrgId) {
      this.selectedOrg = Number(storedOrgId);
    }
  }

  clearSelectedOrg() {
    this.selectedOrg = null;
    localStorage.removeItem('selectedOrg');
  }
}

const organizationStore = new OrganizationStore();
export default organizationStore;
